$shm_hitalama_keepsize $mol_plugin
	zoom 1
	min_zoom 1
	anchor_hor \left
	anchor_vert \bottom
	style *
		^
		transform <= transform \
		translate <= translate \-100% 0
		transformOrigin <= transformOrigin \100% 0
